import { useParams } from 'react-router-dom';
import { createRoute } from 'framework/routing';
import { ACCOUNT_PATH } from 'domain/shared/account';

export const useAccountRoute = () => createRoute({ listRoute: ACCOUNT_PATH, timelinePostfix: 'activities' });

export const useAccountId = () => useParams<Dictionary<string>>().id!;
